import { startOfISOWeek, endOfISOWeek, startOfDay, endOfDay, parse } from 'date-fns';
import { getCurrentLocale } from '@/utils/LocaleUtil.ts';

export const getNoonOfDay = (date) => {
  const newDate = new Date(date);
  newDate.setHours(12, 0, 0, 0);

  return newDate;
};

export const getBeginAndEndOfWeek = (date) => {
  const begin = startOfISOWeek(date);
  const end = endOfISOWeek(date);

  return {
    begin,
    end,
  };
};

export const getBeginAndEndOfDay = (date) => {
  const begin = startOfDay(date);
  const end = endOfDay(date);

  return {
    begin,
    end,
  };
};

export const parseDate = (date: string) => parse(date, 'P', new Date(), { locale: getCurrentLocale() });
